import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import {
  buildBreadcrumbJsonLd,
  buildCanonicalUrl,
  buildWebPageJsonLd,
  organizationJsonLd,
  websiteJsonLd,
} from "@/lib/seo";

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Seo
        title="Privacy Policy | Travel Wings Global"
        description="Understand how Travel Wings Global collects, uses, and protects your data across forex and travel services."
        path="/privacy-policy"
        structuredData={[
          organizationJsonLd,
          websiteJsonLd,
          buildWebPageJsonLd({
            name: "Privacy Policy | Travel Wings Global",
            description:
              "Details on how Travel Wings Global collects, uses, and protects customer data.",
            url: buildCanonicalUrl("/privacy-policy"),
            type: "PrivacyPolicy",
          }),
          buildBreadcrumbJsonLd([
            { name: "Home", url: buildCanonicalUrl("/") },
            { name: "Privacy Policy", url: buildCanonicalUrl("/privacy-policy") },
          ]),
        ]}
      />
      <Navigation />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-xl shadow-lg p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
          
          <div className="prose prose-lg max-w-none text-gray-700">
            <p className="text-sm text-gray-500 mb-8">Last updated: January 1, 2025</p>
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Introduction</h2>
              <p className="mb-4">
                Travel Wings Forex Private Limited (formerly known as Make My Travel (India) Pvt. Ltd.) ("we," "our," or "us") 
                respects your privacy and is committed to protecting your personal data. This privacy policy explains how we 
                collect, use, and safeguard your information when you use our services.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Information We Collect</h2>
              <h3 className="text-xl font-medium text-gray-800 mb-3">2.1 Personal Information</h3>
              <ul className="list-disc pl-6 mb-4">
                <li>Name, address, phone number, and email address</li>
                <li>Passport details and travel documents</li>
                <li>Financial information for forex transactions</li>
                <li>Travel preferences and booking history</li>
              </ul>
              
              <h3 className="text-xl font-medium text-gray-800 mb-3">2.2 Technical Information</h3>
              <ul className="list-disc pl-6 mb-4">
                <li>IP address and device information</li>
                <li>Browser type and version</li>
                <li>Usage data and analytics</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. How We Use Your Information</h2>
              <ul className="list-disc pl-6 mb-4">
                <li>To provide travel and forex services</li>
                <li>To process bookings and transactions</li>
                <li>To comply with legal and regulatory requirements</li>
                <li>To improve our services and customer experience</li>
                <li>To communicate with you about your bookings and services</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Data Sharing and Disclosure</h2>
              <p className="mb-4">
                We may share your personal information with:
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>Airlines, hotels, and other travel service providers</li>
                <li>Payment processors and financial institutions</li>
                <li>Government agencies as required by law</li>
                <li>Authorized third-party service providers</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Data Security</h2>
              <p className="mb-4">
                We implement appropriate technical and organizational measures to protect your personal data against 
                unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over 
                the internet is 100% secure.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Your Rights</h2>
              <p className="mb-4">You have the right to:</p>
              <ul className="list-disc pl-6 mb-4">
                <li>Access your personal data</li>
                <li>Correct inaccurate information</li>
                <li>Request deletion of your data</li>
                <li>Object to processing of your data</li>
                <li>Data portability</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Cookies and Tracking</h2>
              <p className="mb-4">
                We use cookies and similar technologies to enhance your browsing experience, analyze site traffic, 
                and personalize content. You can manage your cookie preferences through your browser settings.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Contact Us</h2>
              <p className="mb-4">
                If you have any questions about this Privacy Policy, please contact us at:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p><strong>Travel Wings Forex Private Limited</strong></p>
                <p>105, 1st Floor, Pocket-B Market, Sarita Vihar, New Delhi-110076</p>
                <p>Email: support@travelwingsonline.in</p>
                <p>Phone: 011-41616942</p>
              </div>
            </section>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
}